import React from 'react';
import { Header } from 'semantic-ui-react';

const InfoExtra: React.FC = () => {
  const style = {
    p: {
      marginTop: '0em',
      marginBottom: '0em',
      color: '#5a5a5a',
      fontSize: '1em',
      fontWeight: 'normal',
    },
    div: {
      padding: '1.5em 0em 0em 0em',
      marginBottom: '2em',
    },
  };
  return (
    <div style={style.div}>
      <Header style={style.p} textAlign="center">
        *O prazo começa a contar a partir da data do pagamento.
      </Header>
      <Header as="p" style={style.p} textAlign="center">
        O valor apresentado é aproximando, e inclui todos os custos inerentes a assessoria, taxas,
        emolumentos e entrega.
      </Header>
    </div>
  );
};

export default InfoExtra;
